import { calculatePaginationOffset, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
export const networkingApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getNetworking: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/networking`,
                params: {
                    search_regex: data.filter.search_regex,
                    tag: data.filter.tag,
                    has_services: data.filter.has_services,
                    classification: data.filter.classification,
                    uri_id: data.filter.uri_id,
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                    sort_by: convertSortToQueryString(data.sort),
                },
            }),
        }),
        getNetworkingSources: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/networking/${data.ui_item_id}/components`,
                params: data,
            }),
        }),
        getNetworkingTags: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/networking/tags`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetNetworkingQuery, useGetNetworkingSourcesQuery, useLazyGetNetworkingTagsQuery, } = networkingApi;
//# sourceMappingURL=networking.api.js.map